export function setStickyElements() {
    let
        stickySocial = $(".sticky"),
        stickyPicture = $('.sticky-img img'),
        $window = $(window);


    $(window).on("load resize", function () {

        if (stickySocial) {
            let isStuck = false;
            if ($window.width() >= 1200) {
                stickySocial.stick_in_parent({
                    parent: '.sticky-holder',
                    offset_top: 186,
                    inner_scrolling: false,
                    recalc_every: 1,
                    spacer: false
                });

                isStuck = true;
            } else {
                if (isStuck) {
                    stickySocial.trigger("sticky_kit:detach");
                    isStuck = false;
                }
            }
        }

        if (stickyPicture) {
            let isStuck = false;

            if ($window.width() >= 768) {
                stickyPicture.stick_in_parent({
                    parent: '.hero-section-picture',
                    offset_top: 144,
                    inner_scrolling: false,
                    recalc_every: 1,
                    spacer: false
                });

                isStuck = true;
            } else {
                if (isStuck) {
                    stickyPicture.trigger("sticky_kit:detach");
                    isStuck = false;
                }
            }
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/stickyElement.js